const {
  version: appVersion,
  myreSentryProjectName,
  // eslint-disable-next-line @typescript-eslint/no-require-imports
} = require('../../package.json');

// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const version = {
  myreSentryProjectName,
  commitHash: '',
  version: appVersion,
  commitMessage: '',
};
